import { combineReducers } from "redux";

import { reducer as boardUserSlice } from "./boardUserSlices";
import { reducer as dropdownButton } from "./dropdownButtons";
import { reducer as shareMenu } from "./shareMenus";
import { reducer as toast } from "./toasts";

export const appReducer = combineReducers({
  dropdownButton,
  shareMenu,
  boardUserSlice,
  toast,
});
